import { AlertTriangle } from "lucide-react";
import { formatPriceCents } from "@/components/services/service-meta";
import { motivoDaPendencia, type ResumoDeMaterial } from "./use-pendencia-material";

/**
 * O custo de material do serviço na planilha, ou o aviso de que ele não fecha.
 *
 * É a contrapartida de não bloquear a conclusão: a pendência precisa estar à vista na tela onde o
 * laboratório olha a produção inteira, senão vira dívida que ninguém encontra.
 *
 * Sem `labCatalog.manage`, `totalCents` vem nulo do servidor — o protético vê a pendência (que é
 * trabalho dele resolver) mas não o dinheiro.
 */
export function CelulaDeMaterial({ resumo }: { resumo: ResumoDeMaterial | undefined }) {
  // Sem `incluirNaoRegistrado`: serviço que ninguém começou a registrar não é pendência aqui, é o
  // estado inicial de todo serviço. Marcar todos de âmbar apagaria o sinal dos que estão de fato
  // pela metade — que são os que alguém precisa terminar.
  const motivo = motivoDaPendencia(resumo, { incluirNaoRegistrado: false });

  if (motivo) {
    return (
      <span
        title={motivo}
        className="inline-flex items-center gap-1 text-[11px] font-medium text-amber-600 dark:text-amber-400"
      >
        <AlertTriangle className="h-3 w-3 shrink-0" />
        {resumo!.emAberto || resumo!.semPreco}
      </span>
    );
  }
  if (!resumo || resumo.linhas === 0) return <span className="text-zinc-300 dark:text-muted-foreground/50">—</span>;
  if (resumo.totalCents == null) {
    return (
      <span title={`${resumo.linhas} insumos registrados`} className="text-[11px] text-zinc-400 dark:text-muted-foreground/70">
        {resumo.linhas} itens
      </span>
    );
  }
  return (
    <span className="text-[11px] tabular-nums text-zinc-700 dark:text-foreground/80">
      {formatPriceCents(resumo.totalCents)}
    </span>
  );
}
